const getters = {
  getMenu (localState, localGetters, state, getters) {
    let abilities = getters['app/abilities']

    return localState.menuLink.filter(item => abilities.includes(item.name))
  }
}

export default getters
